import type { LoanDefinitionType } from '@dealstack/prisma-client';

export const getLoanDefinitionTypeFromTypeName = (
	translation?: string
): LoanDefinitionType | undefined => {
	switch (translation) {
		case 'Management Loan': {
			return 'MANAGEMENT_LOAN';
		}
		case 'Deferred Payment': {
			return 'DEFERRED_PAYMENT';
		}
	}
	return;
};

export const getLoanDefinitionTypeNameFromType = (
	loanDefinitionType: LoanDefinitionType
): string | undefined => {
	switch (loanDefinitionType) {
		case 'MANAGEMENT_LOAN': {
			return 'Management Loan';
		}
		case 'DEFERRED_PAYMENT': {
			return 'Deferred Payment';
		}
	}
};
